module.exports = __webpack_public_path__ + "img/answer_6.6bf2dcbd.png";